<template>
  <nuttrema-layout-form-standard :edit="edit" :saveError="PersonalPassword.saveError">
    <template slot="center">
      <el-form label-width="20em" :model="formData" :rules="rules" :ref="formRef">
        <section>
          <h4 class="section-title">{{ $t('label.current') }}</h4>
          <el-form-item :label="$t('label.current_password')" prop="current_password">
            <el-col class="el-col--min-21em" :span="8">
              <nuttrema-password-input :disabled="!edit" v-model="formData.current_password"></nuttrema-password-input>
            </el-col>
          </el-form-item>
        </section>
        <section>
          <h4 class="section-title">{{ $t('label.new') }}</h4>
          <el-form-item :label="$t('label.new_password')" prop="new_password">
            <el-col class="el-col--min-21em" :span="8">
              <nuttrema-password-input :disabled="!edit" v-model="formData.new_password"></nuttrema-password-input>
            </el-col>
          </el-form-item>
          <el-form-item :label="$t('label.confirm_password')" prop="confirm_password">
            <el-col class="el-col--min-21em" :span="8">
              <nuttrema-password-input :disabled="!edit" v-model="formData.confirm_password"></nuttrema-password-input>
            </el-col>
          </el-form-item>
        </section>
      </el-form>
    </template>
    <template slot="footer">
      <div class="footer-row">
        <el-button
           type="primary"
           size="small"
          :disabled="!isDataChanged"
          :loading="isSaving"
          @click="submitForm">
            {{ $t('label.save') }}
        </el-button>

        <el-button type="text" size="small" @click="cancelChanges(false)">
          <span v-if="showDoneButton">{{ $t('label.done') }}</span>
          <span v-else>{{ $t('label.cancel') }}</span>
        </el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
/* eslint-disable object-shorthand */
import { clone } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';
import NuttremaPasswordInput from 'components/ui/input/nuttrema-password-input';

export default {
  name: 'form-my-prefferences-change-password',
  componentName: 'FormMyPrefferencesChangePassword',
  mixins: [FormStandardBehavior],
  props: {
    PersonalProfile: {
      required: true,
      default: null,
    },
    PersonalPassword: {
      required: false,
      default: null,
    },
    edit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {
    NuttremaPasswordInput,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        current_password: null,
        new_password: null,
        confirm_password: null,
      },
      rules: {
        current_password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
        ],
        new_password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
        ],
        confirm_password: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.confirm_password', true),
          },
          {
            min: 8,
            max: 72,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.password_length'),
          },
          {
            trigger: 'blur',
            validator: this.validatePassword,
            message: this.formatValidationMessage('validation.confirm_password_not_match'),
          },
        ],
      },
    };
  },
  methods: {
    validatePassword(rule, value, callback) {
      if (value !== this.formData.new_password) callback(new Error());
      else callback();
    },
    getFormData() {
      return clone(this.formData);
    },
    resetForm() {
      this.$refs[this.formRef].resetFields();
      this.originalData = clone(this.formData);
    },
  },
  mounted() {
    this.$on('reset', this.resetForm);
  },
  created() {
    this.stateData = this.PersonalPassword;
    this.formRef = 'form-my-prefferences-change-password';
    this.setFormData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/settings/my-preferences/change-password/form-my-prefferences-change-password.vue